// Terminología náutica: "compás magnético" (no "brújula"), "compensación" para el ajuste
// de desvíos, "tablilla de desvíos" para la deviation card, "sociedad de clasificación".
const es = {
    nav: {
        about: 'Nosotros',
        services: 'Servicios',
        contact: 'Contacto',
        language: 'Idioma',
    },
    slides: {
        s1Subtitle: 'Servicios y certificados de compases magnéticos desde 1939.',
        readAbout: 'Conózcanos',
        s2Before: 'Somos la primera empresa en ofrecer el ',
        s2Highlight: 'servicio de compensación remota',
        s2After: ' de compases magnéticos.',
        s2Text: 'Compense su compás magnético a distancia y obtenga todos los certificados necesarios para presentar ante cualquier autoridad nacional o internacional.',
        learnMore: 'Más información',
        getQuote: 'Solicitar cotización',
        imgAlt: 'Puente de un buque con equipos de navegación',
    },
    about: {
        title: 'Nosotros',
        imgAlt: 'Compás magnético en la cubierta de un buque',
        since: 'Desde',
        eyebrow: 'Quiénes somos',
        heading: 'Reparamos y calibramos compases magnéticos desde hace más de 85 años.',
        text: 'Somos el único laboratorio autorizado en la Argentina que emite certificados con todas las validaciones legales e internacionales, aceptados en todo el mundo por cualquier sociedad de clasificación o autoridad de guardacostas.',
        checks: [
            'Autorizados por la PNA (Argentina, Estado miembro de la OMI)',
            'Primer servicio de calibración de compases totalmente remoto',
            'Calibración de compases magnéticos y certificados en menos de 24 h',
        ],
        counters: ['Certificados emitidos', 'Compases reparados', 'Servicios realizados'],
        partner: 'Servicio oficial y distribuidor',
    },
    services: {
        title: 'Servicios',
        flagship: 'Nuestro servicio principal',
        remoteTitle: 'Calibración remota',
        remoteSubtitle: 'Calibre su compás magnético mientras navega, en cualquier parte del mundo. Sin técnico a bordo y sin entrar a puerto.',
        steps: [
            { title: 'Envíe los datos.', text: 'El capitán carga la información del compás en nuestra plataforma online.' },
            { title: 'Reciba las instrucciones.', text: 'Pasos simples y detallados para corregir los desvíos.' },
            { title: 'Compense con asistencia.', text: 'Un técnico está disponible las 24 horas, los 7 días de la semana, para cualquier consulta.' },
            { title: 'Reciba los certificados.', text: 'La nueva tablilla de desvíos y los certificados, por correo electrónico.' },
        ],
        imgAlt: 'Plataforma online',
        figcaption: 'Toda la información del compás en un solo lugar, en nuestra plataforma online.',
        advShipTitle: 'Ventajas para el buque',
        advShip: [
            'Compensación en navegación, sin entrar a puerto ni demorar el viaje',
            'Un técnico disponible las 24 horas, los 7 días de la semana',
        ],
        advOwnersTitle: 'Ventajas para armadores y gestores',
        advOwners: [
            'Sin costos de embarque y desembarque del técnico',
            'Presupuesto fijo, sin recargos por día u horario; más económico por volumen',
        ],
        howItWorks: 'Cómo funciona',
        onboardTitle: 'Calibración a bordo',
        onboardText: 'Un técnico a bordo compensa manualmente el compás magnético y emite los certificados, firmados digitalmente por el técnico y el capitán.',
        onboardSteps: [
            'El técnico le indicará al capitán las maniobras necesarias para verificar y compensar el compás magnético.',
            'Una vez corregidos todos los desvíos, el técnico emitirá a bordo los certificados con todas las validaciones legales e internacionales. Ambos serán firmados digitalmente por el técnico y el capitán.',
        ],
        repairTitle: 'Reparación de compases magnéticos',
        repairText: 'Envíe o traiga su compás a nuestro laboratorio. Reparado en menos de 24 horas, con certificado de reparación y un año de garantía.',
        repairSteps: [
            'Se inspecciona el compás magnético para identificar la falla.',
            'Uno de nuestros técnicos lo repara en menos de 24 horas.',
            'Una vez reparado, nuestro técnico emite el certificado de reparación del compás, con un año de garantía incluido.',
        ],
    },
    contact: {
        title: 'Contacto',
        intro: '¿Necesita una cotización o tiene alguna consulta? Nuestros técnicos le responderán.',
        getInTouch: 'Contáctenos',
        getInTouchText: 'Llámenos, escríbanos o envíenos un mensaje. Atendemos consultas de todo el mundo.',
        international: 'EE. UU. / Internacional',
        technical: 'Departamento técnico',
        email: 'Correo electrónico',
        laboratory: 'Laboratorio',
        openMaps: 'Abrir en Maps',
        whatsapp: 'Escribir por WhatsApp',
        showEmail: 'Ver correo',
        form: {
            title: 'Envíenos un mensaje',
            required: 'Todos los campos son obligatorios.',
            name: 'Nombre completo',
            email: 'Correo electrónico',
            phone: 'Teléfono celular',
            enterprise: 'Empresa',
            subject: 'Asunto',
            message: 'Mensaje',
            recaptcha: 'Protegido por reCAPTCHA.',
            send: 'Enviar mensaje',
            sending: 'Enviando... Por favor, espere.',
            sendError: '¡Algo salió mal! Intente nuevamente más tarde o envíenos un correo electrónico.',
        },
        errors: {
            name: 'El nombre es obligatorio',
            email: 'El correo electrónico es obligatorio',
            emailInvalid: 'El correo electrónico no es válido',
            phone: 'El teléfono celular es obligatorio',
            enterprise: 'La empresa es obligatoria',
            subject: 'El asunto es obligatorio',
            message: 'El mensaje es obligatorio',
        },
    },
    footer: {
        slogan: 'Servicios y certificados de compases magnéticos desde 1939',
        terms: 'Términos y condiciones',
        policy: 'Política de privacidad',
    },
}

export default es
